import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LOGO, NAV_LINKS, SOCIETA_LINKS } from "../../data/content";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const scrollItems = NAV_LINKS.filter((l) => l.type === "scroll");

  const goSection = (id) => {
    if (location.pathname === "/") scrollToId(id);
    else navigate("/#" + id);
  };

  return (
    <footer data-testid="site-footer" className="bg-cream border-t-4 border-navy">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <img src={LOGO} alt="APT 1968 Polisportiva Tricesimo" className="h-16 w-auto object-contain" />
            <p className="font-body text-navy/60 text-sm mt-4 max-w-xs">
              Pallacanestro a Tricesimo e in provincia di Udine dal 1968.
            </p>
          </div>
          <div>
            <div className="font-sub uppercase font-bold tracking-wider text-navy mb-4">Naviga</div>
            <div className="flex flex-col gap-2">
              {scrollItems.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => goSection(l.id)}
                  className="text-left font-body text-navy/70 hover:text-court transition-colors text-sm"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="font-sub uppercase font-bold tracking-wider text-navy mb-4">La Società</div>
            <div className="flex flex-col gap-2">
              {SOCIETA_LINKS.map((l) => (
                <button
                  key={l.to}
                  data-testid={`footer-societa-${l.to.replace("/", "")}`}
                  onClick={() => navigate(l.to)}
                  className="text-left font-body text-navy/70 hover:text-court transition-colors text-sm"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="font-sub uppercase font-bold tracking-wider text-navy mb-4">Contatti</div>
            <p className="font-body text-navy/70 text-sm leading-relaxed">
              Via San Pelagio 17<br />33019 Tricesimo (UD)<br />polisportivatricesimo@gmail.com
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-navy/15 flex flex-col md:flex-row justify-between gap-3 font-body text-xs text-navy/50">
          <span>© {new Date().getFullYear()} Polisportiva Tricesimo | C.F. 80019620303 | P.I. 01603770304 | Tutti i diritti riservati.</span>
          <span className="font-sub uppercase tracking-widest">#ForzaPolisportiva</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
